import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useDeleteClient from '../../../Hooks/clients/useDeleteClient';
import DeleteModal from '../DeleteModal';

function DeleteClientModal({ clientId, refetchClients }) {
  const { t } = useTranslation();
  const [isDeleted, setIsDeleted] = useState(false);
  const { mutate: deleteClient } = useDeleteClient();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    setIsDeleted(false);
  };
  const handleClose = () => setOpen(false);

  const handleChange = event => {
    event.preventDefault();
    return deleteClient(({ clientId }), {
      onSuccess: async () => {
        setIsDeleted(true);
        refetchClients();
      },
      onError: async () => {
        setIsDeleted(false);
      },
    });
  };

  return (
    <DeleteModal
      deletemodaltitle={t('Delete client')}
      deletemodaltext={t('Do you want to delete this client')}
      handleChange={handleChange}
      isDeleted={isDeleted}
      setIsDeleted={setIsDeleted}
      deletedText={t('Client deleted')}
      open={open}
      handleOpen={handleOpen}
      handleClose={handleClose}
    />
  );
}

DeleteClientModal.propTypes = {
  clientId: PropTypes.number,
  refetchClients: PropTypes.func,
};

DeleteClientModal.defaultProps = {
  clientId: '',
};

export default DeleteClientModal;
